// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import all locale files
import enTranslation from "./locales/education-en";
import viTranslation from "./locales/education-vi";
import enVietrroTranslation from "./locales/vietrro-en";
import viVietrroTranslation from "./locales/vietrro-vi";
import viDocumentTranslation from "./locales/document-vi";
import enDocumentTranslation from "./locales/document-en";
//import viEduDashboardTranslation from "./locales/edu-dashboard-vi";
//import enEduDashboardTranslation from "./locales/edu-dashboard-en";
import viManageTranslation from "./locales/manage-vi";
import enManageTranslation from "./locales/manage-en";
import viManagementTranslation from "./locales/manage-p2-vi";
import enManagementTranslation from "./locales/manage-p2-en";
import viUploadDocument from "./locales/upload-document-vi";
import enUploadDocument from "./locales/upload-document-en";
import viNavigation from "./locales/navigation-vi";
import enNavigation from "./locales/navigation-en";
import viViolation from "./locales/violations-vi";
import enViolation from "./locales/violations-en";
import viCertificate from "./locales/certificate-vi";
import enCertificate from "./locales/certificate-en";

import enWorksTranslation from "./locales/en/works";
import viWorksTranslation from "./locales/vi/works";

import enUserTranslation from "./locales/en/user";
import viUserTranslation from "./locales/vi/user";

// Create resources structure
const createResources = () => {
  return {
    en: {
      commonNew: enVietrroTranslation.common || {},
      groups: enVietrroTranslation.userGroup || {},
      loginPage: enVietrroTranslation.pageContent.login || {},
      registerPage: enVietrroTranslation.pageContent.register || {},
      forgotPasswordPage: enVietrroTranslation.pageContent.forgotPassword || {},
      homePage: enVietrroTranslation.pageContent.home || {},
      createContentPage: enWorksTranslation.createContent || {},
      catalogManagementPage: enWorksTranslation.contentManagement || {},
      worksPage: enWorksTranslation.works || {},
      updateMetadataPage: enWorksTranslation.updateMetadata || {},
      publishingPage: enWorksTranslation.publishing || {},
      contentDetailPage: enWorksTranslation.contentDetail || {},

      creatorDashboardPage: enUserTranslation.creatorDashboard || {},

      // Main translation namespace
      translation: enTranslation,

      navigation: enNavigation.navigation || {},

      violationCommon: enViolation.violationCommon || {},
      violations: enViolation.violations || {},
      violationDetails: enViolation.violationDetails || {},

      certificate: enCertificate || {},

      // Education namespace with sub-namespaces
      education: {
        dashboard: enTranslation.education?.dashboard || {},
        documents: enTranslation.education?.documents || {},
        forms: enTranslation.education?.forms || {},
        validation: enTranslation.education?.validation || {},
        navigation: enTranslation.education?.navigation || {},
        subscription: enTranslation.education?.subscription || {},
        payments: enTranslation.education?.payments || {},
        analytics: enTranslation.education?.analytics || {},
        users: enTranslation.education?.users || {},
        admin: enTranslation.education?.admin || {},
        student: enTranslation.education?.student || {},
        settings: enTranslation.education?.settings || {},
        help: enTranslation.education?.help || {},
        notifications: enTranslation.education?.notifications || {},
      },

      // Common namespaces
      common: enTranslation.common || {},
      errors: enTranslation.errors || {},
      user: enTranslation.user || {},
      auth: enTranslation.auth || {},

      // Specific feature namespaces
      document: enDocumentTranslation.documents || {},
      //dashboard: enEduDashboardTranslation.dashboard || {},
      manage: enManageTranslation.manage || {},
      management: enManagementTranslation.management || {},

      // Upload namespace - Fixed structure
      upload: enUploadDocument.upload || {},
    },
    vi: {
      commonNew: viVietrroTranslation.common || {},
      groups: viVietrroTranslation.userGroup || {},
      loginPage: viVietrroTranslation.pageContent.login || {},
      registerPage: viVietrroTranslation.pageContent.register || {},
      forgotPasswordPage: viVietrroTranslation.pageContent.forgotPassword || {},
      homePage: viVietrroTranslation.pageContent.home || {},
      createContentPage: viWorksTranslation.createContent || {},
      catalogManagementPage: viWorksTranslation.contentManagement || {},
      worksPage: viWorksTranslation.works || {},
      updateMetadataPage: viWorksTranslation.updateMetadata || {},
      publishingPage: viWorksTranslation.publishing || {},
      contentDetailPage: viWorksTranslation.contentDetail || {},
      
      creatorDashboardPage: viUserTranslation.creatorDashboard || {},

      // Main translation namespace
      translation: viTranslation,

      navigation: viNavigation.navigation || {},

      violationCommon: viViolation.violationCommon || {},
      violations: viViolation.violations || {},
      violationDetails: viViolation.violationDetails || {},
      
      certificate: viCertificate || {},

      // Education namespace with sub-namespaces
      education: {
        dashboard: viTranslation.education?.dashboard || {},
        documents: viTranslation.education?.documents || {},
        forms: viTranslation.education?.forms || {},
        validation: viTranslation.education?.validation || {},
        navigation: viTranslation.education?.navigation || {},
        subscription: viTranslation.education?.subscription || {},
        payments: viTranslation.education?.payments || {},
        analytics: viTranslation.education?.analytics || {},
        users: viTranslation.education?.users || {},
        admin: viTranslation.education?.admin || {},
        student: viTranslation.education?.student || {},
        settings: viTranslation.education?.settings || {},
        help: viTranslation.education?.help || {},
        notifications: viTranslation.education?.notifications || {},
      },

      // Common namespaces
      common: viTranslation.common || {},
      errors: viTranslation.errors || {},
      user: viTranslation.user || {},
      auth: viTranslation.auth || {},

      // Specific feature namespaces
      document: viDocumentTranslation.documents || {},
      //dashboard: viEduDashboardTranslation.dashboard || {},
      manage: viManageTranslation.manage || {},
      management: viManagementTranslation.management || {},

      // Upload namespace - Fixed structure
      upload: viUploadDocument.upload || {},
    },
  };
};

// Initialize i18n
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: createResources(),
    // fallbackLng: "vi",
    debug: import.meta.env.NODE_ENV === "development",

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
      defaultVariables: {
        extensionsSupport: 'JPG, PNG, MP4, PDF',
        maxSizeSupport: '10MB'
      }
    },

    // Default namespace
    defaultNS: "translation",

    // All available namespaces
    ns: [
      "commonNew",
      "loginPage",
      "registerPage",
      "forgotPasswordPage",
      "homePage",
      "translation",
      "education",
      "education.dashboard",
      "education.documents",
      "education.forms",
      "education.validation",
      "education.navigation",
      "education.subscription",
      "education.payments",
      "education.analytics",
      "education.users",
      "education.admin",
      "education.student",
      "education.settings",
      "education.help",
      "education.notifications",
      "common",
      "errors",
      "user",
      "auth",
      "document",
      "dashboard",
      "manage",
      "manage.dashboard",
      "manage.catalog",
      "manage.contracts",
      "manage.payments",
      "manage.violations",
      "manage.legalEnforcement",
      "manage.disputes",
      "manage.licenseRevocation",
      "manage.identityProtection",
      "manage.aiScan",
      "manage.system",
      "manage.apiManagement",
      "manage.admin",
      "manage.licensePurchase",
      "management.rights",
      "management.works",
      "management.licenses",
      "management.contracts",
      "management.violations",
      "management.reportViolation",
      "management.ViolationDetail",
      "management.revenue",
      "management.payment",
      "management.settings",
      "management.catalog",
      "management.profile",
      "management.common",
      "management.error",
      "upload", // Fixed upload namespace
      "navigation",
    ],

    // React options
    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      transEmptyNodeValue: "",
    },

    // Detection options
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"],
    },
  });

// Utility function to change language with notification
export const changeLanguage = async (language: string) => {
  try {
    await i18n.changeLanguage(language);
    // Save language to localStorage to persist on page reload
    localStorage.setItem("i18nextLng", language);

    // Debug log
    if (import.meta.env.NODE_ENV === "development") {
      console.log("Language changed to:", language);
      console.log(
        "Available resources:",
        Object.keys(i18n.getResourceBundle(language, "upload") || {})
      );
    }

    return true;
  } catch (error) {
    console.error("Failed to change language:", error);
    return false;
  }
};

// Function to get current language
export const getCurrentLanguage = () => {
  return i18n.language || "vi";
};

// Function to check if translation exists
export const hasTranslation = (key: string, namespace?: string) => {
  return i18n.exists(key, { ns: namespace });
};

// Function to get all available languages
export const getAvailableLanguages = () => {
  return Object.keys(i18n.options.resources || {});
};

// Function to get translation with fallback
export const getTranslationWithFallback = (
  key: string,
  namespace?: string,
  fallback?: string
) => {
  if (i18n.exists(key, { ns: namespace })) {
    return i18n.t(key, { ns: namespace });
  }
  return fallback || key;
};

// Debug function for development
export const debugI18n = () => {
  if (import.meta.env.NODE_ENV === "development") {
    console.group("i18n Debug Information");
    console.log("Current language:", i18n.language);
    console.log("Fallback language:", i18n.options.fallbackLng);
    console.log("Available languages:", getAvailableLanguages());
    console.log("Available namespaces:", i18n.options.ns);
    console.log(
      "Upload namespace exists:",
      i18n.hasResourceBundle(i18n.language, "upload")
    );
    console.log(
      "Upload resources:",
      i18n.getResourceBundle(i18n.language, "upload")
    );
    console.groupEnd();
  }
};

export default i18n;
